import { IconCar16, IconWalk16 } from '@cian/ui-kit';

import { ETravelType } from 'shared/repositories/coworking/entities/underground/UndergroundSchema';

export const getIconTravel = (travelType: ETravelType) => {
  if (travelType === ETravelType.ByFoot) {
    return IconWalk16;
  }

  return IconCar16;
};
